import { hideSpinner } from "./loading";

interface FormElement {
  key: string;
  label: string;
  password: boolean;
  tags: null;
  type: "input";
  validator: {
    required: boolean;
  };
}

interface ICpfForm {
  form_identifier: string;
  elements: FormElement[];
}

const cpfContainerElement = document.getElementById("cpf-container");
const confirmPaymentElement = document.getElementById("confirm-payment");
const cpfLegendElement = document.getElementById("cpf-legend");
const cpfFieldsetElement = document.getElementById("cpf-fieldset");
const cpfErrorMessageElement = document.getElementById("cpf-error-message");
const cpfInputElement = document.getElementById("cpf-input") as HTMLInputElement;
const cpfSubmitButton = document.getElementById("cpf-submit") as HTMLButtonElement;

export const setupCpfForm = (form: ICpfForm) => {
  let validCPF: boolean = false;

  if (form.elements && confirmPaymentElement && cpfLegendElement) {
    cpfSubmitButton.disabled = true;
    cpfSubmitButton.classList.add("disabled");
    cpfLegendElement.innerHTML = "CPF";
    cpfInputElement?.setAttribute("placeholder", "000.000.000-00");

    cpfInputElement?.addEventListener("input", (event) => {
      const target = event.target as HTMLInputElement;

      // Validate the CPF
      validCPF = checksumCPF(stripCpf(target.value));

      cpfInputElement.setAttribute("aria-invalid", validCPF ? "false" : "true");
      cpfSubmitButton.classList.toggle("disabled", !validCPF);
      cpfSubmitButton.disabled = !validCPF;

      cpfFieldsetElement?.classList.toggle("invalid", !validCPF);
      cpfLegendElement?.classList.toggle("invalid", !validCPF);
      cpfErrorMessageElement?.classList.toggle("invalid", !validCPF);
    });

    console.log("showing cpf form");
  }

  hideSpinner();
};

export const hideCpfForm = () => {
  if (cpfContainerElement) {
    cpfContainerElement.style.display = "none";
  }
};

export const showCpfForm = () => {
  if (cpfContainerElement) {
    cpfContainerElement.hasAttribute("style") && cpfContainerElement.removeAttribute("style");
  }
};

export const stripCpf = (formatedCpf: string): string => {
  return formatedCpf.replaceAll(".", "").replaceAll("-", "");
};

const checksumCPF = (cpf: string): boolean => {
  // It's an 11-digit number in the format 000.000.000-00, where the last 2 numbers are check digits,
  // generated through an arithmetic operation on the first nine digits.

  if (cpf.length !== 11) {
    return false;
  }

  let sum = 0;

  const firstCN = parseInt(cpf.charAt(9), 10);
  const secondCN = parseInt(cpf.charAt(10), 10);

  const checkResult = (sum: number, cn: number) => {
    let result = (sum * 10) % 11;
    if (result === 10 || result === 11) {
      result = 0;
    }

    return result === cn;
  };

  // Step 1 - using first Check Number
  for (let i = 1; i <= 9; i++) {
    sum = sum + parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
  }

  if (checkResult(sum, firstCN)) {
    let cnSum = 0;

    for (let i = 1; i <= 10; i++) {
      cnSum = cnSum + parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
    }

    return checkResult(cnSum, secondCN);
  }

  return false;
};
